// extracted by mini-css-extract-plugin
export var blockBtn = "main-module--block-btn--6e0b7";
export var mainBtn = "main-module--main-btn--6ef69";
export var mainTitle = "main-module--main-title--bfdf7";
export var title = "main-module--title--dc52c";